module.exports = __webpack_public_path__ + "img/bar1.841660d8.svg";